var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWattAttackLogoShortLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 327,
    viewBox: "0 0 441 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.63 306 5.23 24.8h68.04l22.84 197.46L119.42 24.8h55.2l23.31 197.46L220.77 24.8h68.52L247.4 306h-77.07l-23.32-142.26L123.71 306H46.63Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.48 306 270.2 24.8h96.59L410.56 306h-73.75l-6.18-46.15h-28.55L296.85 306h-71.37Zm77.08-78.5h28.07l-13.8-147.98-14.27 147.97Z",
    fill: "#FC5900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWattAttackLogoShortLight);
export default __webpack_public_path__ + "static/media/WattAttackLogoShortLight.ba550d81727bd1942ea6bd5a015cf510.svg";
export { ForwardRef as ReactComponent };